import { gql } from "apollo-angular";

export const GETALL_SPECIFICATION_COVERAGE_QUERY = gql`query configuratorAllSpecificationCoverage($RegBy: String) {
    configuratorAllSpecificationCoverages(RegBy: $RegBy) {
        Version
        Uid
        ItemNo
        Name
        ModifiedBy
        ModificationTime
        LockedTime
        LockedBy
        CreationTime
        CreatedBy
        Comment
        ApprovedForTestLevel
        ApprovalStatus
    }
  }
  `
  
export const GET_SPECIFICATION_COVERAGE_QUERY = gql`query configuratorSpecificationCoverageById($Uid: String!) {
    configuratorSpecificationCoverageById(Uid: $Uid) {
        responseMessages
        returnValue
        success
    }
  }
  `

export const GET_SPECIFICATION_COVERAGE_UI_TEMPLATE_QUERY = gql`query configuratorSpecificationCoverageUiTemplate {
    configuratorSpecificationCoverageUiTemplate {
        Name
        Category
        DefaultValue
        FieldType
        IsMultiValue
        HasHierarchyValues
        IsReadOnly
        Label
        IsRequired
        Order
        Tooltip
        ValueList
    }
  }
  `
export const GET_SPECIFICATION_COVERAGE_SEARCH_UI_TEMPLATE_QUERY = gql`query configuratorSpecificationCoverageSearchUiTemplate {
    configuratorSpecificationCoverageSearchUiTemplate {
        Name
        Label
        Category
        DefaultValue
        Order
        FieldType
        Tooltip
        IsReadOnly
        IsRequired
        IsMultiValue
        HasHierarchyValues
        ValueList
    }
  }
  `

export const SEARCH_SPECIFICATION_COVERAGE_QUERY = gql`query configuratorSearchSpecificationCoverage($SpecificationCoverage: SpecificationCoverageInput) {
  configuratorSearchSpecificationCoverage(SpecificationCoverage: $SpecificationCoverage) {
        Version
        Uid
        ItemNo
        Name
        ModifiedBy
        ModificationTime
        LockedTime
        LockedBy
        CreationTime
        CreatedBy
        Comment
        ApprovedForTestLevel
        ApprovalStatus
    }
}
`